<ion-card>
  <ion-card-header>
    <div class="header-container">
      <div class="titulo-con-informacion">
        <ion-card-title>{{ titulo }}</ion-card-title>
        <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
          aria-label="Información">
          <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>
  </ion-card-header>
  <ion-card-content>
    <!-- Estado de carga -->
    <ng-container *ngIf="cargando; else contenidoCargado">
      <div class="loading-container">
        <ion-spinner name="crescent" color="medium"></ion-spinner>
      </div>
      <ion-icon [name]="icono" [attr.color]="colorIconoCustom ? null : colorIcono" [style.color]="colorIconoCustom || null" class="icono-cargando"></ion-icon>
    </ng-container>

    <!-- Contenido cargado -->
    <ng-template #contenidoCargado>
      <div class="contenido-principal">
        <div class="valor-estadistica">
          <ng-container *ngIf="valor !== null && valor !== undefined">
            {{ valor | chileanNumber:2 }}{{ sufijo }}
          </ng-container>
        </div>
        <div class="fila-subtitulo-icono">
          <span class="subtitulo" *ngIf="subtitulo">{{ subtitulo }}</span>
          <ion-icon [name]="icono" [attr.color]="colorIconoCustom ? null : colorIcono" [style.color]="colorIconoCustom || null" class="icono-inferior"></ion-icon>
        </div>
      </div>
    </ng-template>
  </ion-card-content>
</ion-card>

<!-- Popover de información: side="top" y reference="trigger" para alineación correcta en iPad/Chrome -->
<ion-popover *ngIf="informacion" [trigger]="idUnico" [triggerAction]="'click'" reference="trigger"
  [side]="'top'" [alignment]="'center'">
  <ng-template>
    <div class="popover-informacion">
      <p>{{ informacion }}</p>
    </div>
  </ng-template>
</ion-popover>